import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import hviCoverImg from "./../images/hvi-cover-img.jpg";
import {Helmet} from "react-helmet";
import Navigation from "../partials/Navigation";
import HorizontalNav from "../partials/Dashboard/HorizontalNav";
import configVars from "../config";
import TeamBars from "../partials/Dashboard/Charts/TeamBars";
import OfflineColumnChart from "../partials/HVI/OfflineColumnChart";
import OfflinePieChart from "../partials/HVI/OfflinePieChart";

const OfflineOviResults = () => {

    const { company } = useParams();
    const [graphData, setGraphData] = useState({});
    const [average, setAverage] = useState(0);
    const [totalUsers, setTotalUsers] = useState(0);
    const [loading, setLoading] = useState(false);
    const [redPeople, setRedPeople] = useState(0);
    const [yellowOnePeople, setYellowOnePeople] = useState(0);
    const [yellowTwoPeople, setYellowTwoPeople] = useState(0);
    const [greenPeople, setGreenPeople] = useState(0);

    useEffect(() => {

        setLoading(true);

        (async () => {
				
            const response = await fetch(
                `${configVars.apiUrl}sustainchange/v1/getofflinehvi/?company=${company}&type=ovi`,
                {
                    method: "GET",
                    headers: {
                        Authorization: `Basic ${configVars.auth}`,
                    },
                }
            );
            
            const hviResponse = await response.json();

            if ( hviResponse ) {

                if ( hviResponse.success === true ) {

                    let hviData = hviResponse.data.company_hvi;
                    let teamHvi = {
                        red: [0,0,0,0,0,0,0,0,0,0,0,0],
                        yellow: [0,0,0,0,0,0,0,0,0,0,0,0],
                        green: [0,0,0,0,0,0,0,0,0,0,0,0]
                    };

                    setTotalUsers( hviData.length );

                    let red = 0;
                    let yellowOne = 0;
                    let yellowTwo = 0;
                    let green = 0;

                    hviData.map( ( userData ) => {

                        let totalPoints = 0;

                        userData.map( (value, index ) => {

                            totalPoints = totalPoints + value;

                            if ( value === 0 || value === 1 || value === 2 ) {
        
                                teamHvi.red[index] = teamHvi.red[index] + 1;
                            }
            
                            if ( value === 3 || value === 4 ) {
            
                                teamHvi.yellow[index] = teamHvi.yellow[index] + 1;
                            }
            
                            if ( value === 5 || value === 6 ) {
            
                                teamHvi.green[index] = teamHvi.green[index] + 1;
                            }
                
                            return value;

                        });

                        if ( totalPoints > 12 && totalPoints <= 24 ) {
                            red = red + 1;
                        }

                        if ( totalPoints > 24 &&  totalPoints <= 41 ) {
                            yellowOne = yellowOne + 1; 
                        }

                        if ( totalPoints >= 60 ) {
                            green = green + 1;
                        }

                        if ( totalPoints >= 42 &&  totalPoints <= 59 ) {
                            yellowTwo = yellowTwo + 1;
                        }

                        return userData;
                        
                    });

                    teamHvi.red.map( (hvival, index) => (
                        teamHvi.red[index] = parseInt( (hvival*100)/hviData.length, 10 )
                    ));
                    teamHvi.yellow.map( (hvival, index) => (
                        teamHvi.yellow[index] = parseInt( (hvival*100)/hviData.length, 10 )
                    ));
                    teamHvi.green.map( (hvival, index) => (
                        teamHvi.green[index] = parseInt( (hvival*100)/hviData.length, 10 )
                    ));

                    setGraphData( teamHvi );
                    setAverage( hviResponse.data.hvi_average );

                    setRedPeople( red );
                    setYellowOnePeople( yellowOne );
                    setGreenPeople( green );
                    setYellowTwoPeople( yellowTwo );

                    //console.log( hviData );
                    //console.log( teamHvi );

                }

                //console.log( hviResponse.data );

            }

            setLoading(false);

        })()

    }, [company]);

    const getHviColor = (count) => {
		let color = 'sy-red';

		if ( count > 24 && count < 60 ) {
			color = 'sy-yellow';
		}

		if ( count > 59 ) {
			color = 'dark-green';
		}

		return color;
	}

    return (
        <div className="main-wrapper">
			<Helmet>
				<title>Organisation Well function Index (OWI)</title>
				<meta name="description" content="" />
			</Helmet>
			<Navigation />

			<div className="page-content-wrap">
				<HorizontalNav title="Välkommen" />
				
				<div className="pt-5 pt-lg-0 page-content-inner">
					<div className="course-img-wrap d-flex overflow-hidden position-relative" style={{maxHeight: '300px',backgroundImage: `url(${hviCoverImg})`, backgroundSize: 'cover', backgroundPosition: 'center', height: '300px'}}>
						<div className="position-absolute w-100 h-100 top-0 left-0 dark-overlay d-flex justify-content-center align-items-center">
							<h1 className="text-white display-1 text-center text-shadow">Organisation Well function Index (OWI)</h1>
						</div>
					</div>

						<div className="px-4" style={{maxWidth: '1400px'}}>
                            <div className="hvi-wrap mt-5 d-flex align-items-center">
                                <span className="h5 me-2">Team OWI (medelvärde):</span>
                                <span className={`text-white h5 py-3 px-4 bg-${getHviColor(average)}`}>{average}</span>
                            </div>
                            <div className="hvi-wrap mt-3 d-flex align-items-center">
                                <span className="h5 me-2">Totalt antal som svarat:</span>
                                <span className="h5">{totalUsers}</span>
                            </div>
                            <div className="hvi-wrap mt-3">
                                <div className="row">
                                    <div className="col-12 col-lg-6">
                                        <OfflineColumnChart totalUsers={totalUsers} data={[redPeople, yellowOnePeople, yellowTwoPeople, greenPeople]} title="Team OWI - antal per resultatkategori" />
                                    </div>
                                    <div className="col-12 col-lg-6">
                                        <OfflinePieChart totalUsers={totalUsers} data={[redPeople, yellowOnePeople, yellowTwoPeople, greenPeople]} title="Team OWI - antal per resultatkategori (procent)" />
                                    </div>
                                </div>
                            </div>
							<div className="hvi-wrap mt-5">
                                <TeamBars hviValues={graphData} loading={loading}
                                title="Team OWI - fördelning per fråga"
                                questions={[
                                    'Tydliga visioner och mål',
                                    'Bidrar till organisationens resultat',
                                    'Prioriterar varje dag',
                                    'Tydliga ansvarsområden och mål',
                                    'Resurser för arbetsuppgifterna',
                                    'Värderingarna är viktiga',
                                    'Arbetet är meningsfullt och engagerar',
                                    'Tillit till sin chef',
                                    'Kollegialt stöd',
                                    'Trygg i gruppen och kan vara sig själv',
                                    'Hinner genomföra förändringar',
                                    'Förtroende för ledningen'
                                ]} />
							</div>
						</div>
				</div>

			</div>
		</div>
    );
}

export default OfflineOviResults;